export const TesterTools = () => {
  return (
    <div className='flex flex-col gap-3 p-4'>
      <p className='text-sm text-muted-foreground'>
        Developer tools panel — game instance controls coming in Phase 9.
      </p>
    </div>
  );
};
